import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div className="about">
        <h2>About</h2>
        <p>
          Weather OR Not is an experimental project exploring a data driven GIS
          & d3.js frontend.
        </p>
        <p>Built using the following technologies:</p>

        <ul>
          <li>React</li>
          <li>D3.js</li>
          <li>Mapbox</li>
          <li>
            Data from{" "}
            <a href="http://api.openweathermap.org" target="_blank">
              OpenWeather
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default About;
